{
  "id": "campaign-035",
  "name": "Merry Commons",
  "seed": "campaign:35",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "........._..",
    "........._..",
    ".....#..._..",
    "____________",
    ".......x._..",
    "~..b....b_..",
    "........._..",
    "~........_..",
    "........._,.",
    "........._,,",
    ".*.*.**.*_*.",
    "........._..",
    "........._..",
    "....l..l._..",
    "........._..",
    ".l.l....l_l.",
    "............",
    "...........S"
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 6,
      "y": 9
    },
    {
      "kind": "squirrel",
      "x": 0,
      "y": 1
    },
    {
      "kind": "squirrel",
      "x": 0,
      "y": 8
    },
    {
      "kind": "squirrel",
      "x": 1,
      "y": 17
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 3,
      "y": 14
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 15
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 6
    }
  ],
  "generatorVersion": 3,
  "level": 35,
  "biome": "park",
  "par": {
    "reel": 6648,
    "push": 5793,
    "selfPropelled": 5346,
    "tractor": 4865,
    "zeroTurn": 3781,
    "fairway": 2322
  },
  "routeTries": {
    "par": {
      "reel": 10,
      "push": 0,
      "selfPropelled": 0,
      "tractor": 0,
      "zeroTurn": 14,
      "fairway": 18
    }
  }
}
